import { useNavigate } from 'react-router-dom';
import './ArticleCard.css';

function ArticleCard({ id, title, image, date, author, source, link, content, summary }) {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/article/${id}`);
  };

  return (
    <div className="article-card" onClick={handleCardClick}>
      <img src={image} alt={title} className="article-image" />
      <div className="article-content">
        <h3 className="article-title">{title}</h3>
        <div className="article-meta">
          <p className="article-date">{date}</p>
          <p className="article-author">by {author}</p>
        </div>
        <p className="article-summary">{summary}</p>
      </div>
    </div>
  );
}

export default ArticleCard;
